import React, { useRef, useEffect } from 'react';

export function RequestCancellation<P extends { abortSignal: AbortSignal }>(
  WrappedComponent: React.ComponentType<P>
) {
  return (props: Omit<P, 'abortSignal'>) => {
    const controllerRef = useRef<AbortController | null>(null);

    if (!controllerRef.current) {
      controllerRef.current = new AbortController();
    }

    useEffect(() => {
      return () => {
        controllerRef.current?.abort();
      };
    }, []);

    const abortSignal = controllerRef.current.signal;

    return <WrappedComponent {...(props as P)} abortSignal={abortSignal} />;
  };
}
